import React from 'react';
import { useTranslation } from 'react-i18next';
import Select, { SingleValue } from 'react-select';

type BotFilterValue = null | boolean;

interface BotOption {
  value: BotFilterValue;
  label: string;
}

interface BotsChooserProps {
  onChange: (value: BotFilterValue) => void;
  value?: BotFilterValue;
  disableShowOnly?: boolean;
}

export const BotsChooser: React.FC<BotsChooserProps> = ({onChange, value = null, disableShowOnly = false}) => {
  const { t } = useTranslation();

  const options: BotOption[] = [
    { value: null, label: t('Include inauthentic actors') },
    { value: false, label: t('Exclude inauthentic actors') },
    { value: true, label: t('Show only inauthentic actors') }
  ];

  const handleChange = (selectedOption: SingleValue<BotOption>) => {
    // Prevent selecting "Show only" if it's disabled
    if (selectedOption?.value === true && disableShowOnly) {
      return;
    }
    onChange(selectedOption?.value ?? null);
  };

  const selectedOption = options.find(option => option.value === value) || options[0];

  return(
    <div className='chooser bot-chooser'>
      <Select
        className="select-filter"
        classNamePrefix="select-filter"
        options={options.map(option => ({
          ...option,
          isDisabled: option.value === true && disableShowOnly
        }))}
        value={selectedOption}
        onChange={handleChange}
        placeholder={t('Select inauthentic behavior')}
        isClearable={false}
      />
    </div>
  )
}

